<script setup lang="ts">
// import type { BlogPost } from '~/types'

const { data: page } = await useAsyncData('blog-page', () => queryCollection('pages').first())
if (!page.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page not found', fatal: true })
}

const { data: posts } = await useAsyncData('blog', () => queryCollection('blog').all())

useSeoMeta({
  title: page.value.title,
  ogTitle: page.value.title,
  description: page.value.description,
  ogDescription: page.value.description
})

// defineOgImage({
//   component: 'OgImage',
//   title: page.value.title,
//   description: page.value.description
// })
const head = {
  title: `Our Blog | BuiltByFew`,
  description: 'A no fluff blog.'
}

defineOgImageComponent('OgImage', {
  title: head.title,
  description: head.description,
})
</script>

<template>
  <UContainer>
    <UPageHeader
      v-bind="page"
      class="py-[50px]"
    />
    <UPageBody>

      <UBlogPosts>
        <UBlogPost
          v-for="(post, index) in posts"
          :key="`blog-${index}`"
          v-bind="post"
          :to="post.path"
          :title="post.title"
          :description="post.description"
          :image="post.meta.image"
          :date="new Date(post.meta.date).toLocaleDateString('en', { year: 'numeric', month: 'short', day: 'numeric' })"
          :authors="post.meta.authors"
          :badge="post.meta.badge"
          :orientation="index === 0 ? 'horizontal' : 'vertical'"
          :class="[index === 0 && 'col-span-full']"
          :ui="{
            description: 'line-clamp-2'
          }"
        />
      </UBlogPosts>
    </UPageBody>
  </UContainer>
</template>
